// import React, { useState, useEffect } from 'react';
// import './BengaliCalender.scss';
// import calendar from '../../assets/calendar.png';
// import moon from '../../assets/moon.png';
// import scroll from '../../assets/scroll.png';
// import weekDay from '../../assets/weekDay.png';
// import t from '../../assets/t.png';
// import hourglass from '../../assets/hourglass.png';
// import setting from '../../assets/setting.png';
// import tool from '../../assets/tool.png';
// import axios from 'axios';
// import city from '../../city.json';

// const BengaliCalendar = ({ dateType = "bengali" }) => {
//   const [showWeekdays, setShowWeekdays] = useState(false);
//   const [currentDate, setCurrentDate] = useState(new Date()); // fixed: original "now" (kept)
//   // --- NEW: selectedDate drives the overview (initially equals currentDate) ---
//   const [selectedDate, setSelectedDate] = useState(new Date());

//   const [location, setLocation] = useState("Kolkata, India");
//   const [year, setYear] = useState(currentDate.getFullYear());
//   const [month, setMonth] = useState(currentDate.getMonth());
//   const [calendarData, setCalendarData] = useState([]);
//   const [tempLocation, setTempLocation] = useState("Kolkata");
//   const [suggestions, setSuggestions] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const daysInMonth = (m, y) => new Date(y, m + 1, 0).getDate();
//   const getFirstDay = (m, y) => new Date(y, m, 1).getDay();

//   const fetchCalendarData = async () => {
//     if (!location || location.trim() === '') return;
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `https://core-c343.onrender.com/api/calendar-month?location=${encodeURIComponent(location)}&year=${year}&month=${month + 1}`
//       );
//       setCalendarData(res.data || []);
//     } catch (err) {
//       console.error('Error fetching calendar data:', err);
//       setCalendarData([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Keep existing behavior: fetch whenever year/month/location changes (debounced)
//   useEffect(() => {
//     const debounce = setTimeout(fetchCalendarData, 500);
//     return () => clearTimeout(debounce);
//   }, [year, month, location]);

//   const generateDays = () => {
//     const totalDays = daysInMonth(month, year);
//     const startDay = getFirstDay(month, year);
//     const prevMonthDays = daysInMonth(month - 1 < 0 ? 11 : month - 1, month - 1 < 0 ? year - 1 : year);

//     const days = [];

//     for (let i = startDay - 1; i >= 0; i--) {
//       days.push({
//         date: prevMonthDays - i,
//         tithi: '-',
//         sunrise: '-',
//         sunset: '-',
//         bengaliDate: '-',
//         hinduDate: '-',
//         blurred: true
//       });
//     }

//     for (let i = 1; i <= totalDays; i++) {
//       const apiDay = calendarData.find(item => new Date(item.date).getDate() === i);
//       const date = new Date(year, month, i);

//       // --- UPDATED: isToday compares with selectedDate (so the highlighted day follows chosen date) ---
//       const isToday = date.toDateString() === selectedDate.toDateString();

//       days.push({
//         date: i,
//         tithi: apiDay?.tithi?.name || '-',
//         sunrise: apiDay?.sunrise || '-',
//         sunset: apiDay?.sunset || '-',
//         bengaliDate: apiDay?.bengaliDate?.formatted || '-',
//         event: i === 14 ? 'Rath' : i === 25 ? 'monthly shivratri' : '',
//         nakshatra: apiDay?.nakshatra?.name,
//         yoga: apiDay?.yoga?.name,
//         isToday,
//         fullDate: date
//       });
//     }

//     while (days.length % 7 !== 0) {
//       days.push({
//         date: days.length % 31 + 1,
//         tithi: '-',
//         sunrise: '-',
//         sunset: '-',
//         bengaliDate: '-',
//         hinduDate: '-',
//         blurred: true
//       });
//     }

//     return days;
//   };

//   const days = generateDays();

//   // --- UPDATED: find today's API data using selectedDate instead of fixed currentDate ---
//   const todayData = calendarData.find(
//     (item) => new Date(item.date).toDateString() === selectedDate.toDateString()
//   );

//   // --- UPDATED: today overview uses selectedDate (so it changes when selectedDate changes) ---
//   const today = {
//     date: selectedDate.getDate(),
//     month: selectedDate.getMonth(),
//     year: selectedDate.getFullYear(),
//     weekday: selectedDate.toLocaleString('default', { weekday: 'long' }),
//     monthName: selectedDate.toLocaleString('default', { month: 'long' }),
//     bengaliDate: todayData?.bengaliDate?.formatted || 'Loading',
//     hinduDate: todayData?.hinduDate?.formatted || 'Loading',
//     paksha: todayData?.paksha || 'Loading...',
//     vikramSamvat: todayData?.vikramSamvat?.formatted || 'Loading...',
//     shakaSamvat: todayData?.shakaSamvatDetails?.formatted || 'Loading...',
//     bengaliYear: todayData?.shakaSamvatDetails?.year || selectedDate.getFullYear(),
//     hinduYear: todayData?.vikramSamvat?.year || selectedDate.getFullYear(),
//     tithi: todayData?.tithi || 'Loading...'
//   };

//   const weekdayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

//   const rows = 7;
//   const columns = Math.ceil(days.length / rows);
//   const calendarMatrix = Array.from({ length: rows }, (_, rowIndex) =>
//     Array.from({ length: columns }, (_, colIndex) => {
//       const dayIndex = colIndex * rows + rowIndex;
//       return days[dayIndex] || null;
//     })
//   );

//   const handlePrev = () => {
//     let newMonth, newYear;
//     if (month === 0) {
//       newMonth = 11;
//       newYear = year - 1;
//     } else {
//       newMonth = month - 1;
//       newYear = year;
//     }

//     // update month/year (keeps other behaviour)
//     setMonth(newMonth);
//     setYear(newYear);

//     // adjust selectedDate to same day-of-month where possible
//     const day = selectedDate.getDate();
//     const maxDay = daysInMonth(newMonth, newYear);
//     const dayToUse = Math.min(day, maxDay);
//     setSelectedDate(new Date(newYear, newMonth, dayToUse));
//   };

//   const handleNext = () => {
//     let newMonth, newYear;
//     if (month === 11) {
//       newMonth = 0;
//       newYear = year + 1;
//     } else {
//       newMonth = month + 1;
//       newYear = year;
//     }

//     setMonth(newMonth);
//     setYear(newYear);

//     // adjust selectedDate to same day-of-month where possible
//     const day = selectedDate.getDate();
//     const maxDay = daysInMonth(newMonth, newYear);
//     const dayToUse = Math.min(day, maxDay);
//     setSelectedDate(new Date(newYear, newMonth, dayToUse));
//   };

//   const handleChange = (e) => {
//     const value = e.target.value;
//     setTempLocation(value);

//     if (value.length > 0) {
//       const filtered = city.filter((c) =>
//         c.city.toLowerCase().includes(value.toLowerCase())
//       );
//       setSuggestions(filtered.slice(0, 4));
//     } else {
//       setSuggestions([]);
//     }
//   };

//   const handleSelect = (cityName) => {
//     setTempLocation(cityName);
//     setSuggestions([]);
//   };

//   // --- NEW: Submit sets location and triggers API fetch immediately ---
//   const handleSubmit = () => {
//     // apply the typed location and reload data
//     setLocation(tempLocation);
//     // Ensure month/year reflect selectedDate (if user changed date input earlier)
//     setMonth(selectedDate.getMonth());
//     setYear(selectedDate.getFullYear());

//     // Call fetchCalendarData to reload right away (use the latest states)
//     // Note: fetchCalendarData uses the closure values of location/year/month.
//     // To ensure it uses updated location/year/month immediately, call after small tick:
//     setTimeout(() => {
//       fetchCalendarData();
//     }, 0);
//   };
// const handleToday = async () => {
//   const now = new Date();

//   // 🔁 Update the selected date so date-overview re-renders
//   setSelectedDate(now);

//   // 🔁 Update currentDate (optional if you use it elsewhere)
//   setCurrentDate(now);

//   // 🔁 Update month/year so API uses correct current month
//   setYear(now.getFullYear());
//   setMonth(now.getMonth());

//   try {
//     setLoading(true);
//     await fetchCalendarData(); // fetch new data for today’s month
//   } catch (err) {
//     console.error('Today click fetch error', err);
//   } finally {
//     setLoading(false);
//   }
// };



//   return (
//     <section className="bengali-calendar">
//       <div className="calendar-container">
//         <div className="calendar-header">
//           <div className="calendar-info">
//             <div className="nav-buttons">
//               <button className="prev" onClick={handlePrev}>Prev</button>
//             </div>
//             <div className="month-date">
//               <h2>{new Date(year, month).toLocaleString('default', { month: 'long' })} {year}</h2>
//               <p>
//                 {dateType === "bengali" ? today.bengaliDate : today.hinduDate}
//               </p>
//             </div>
//             <div className="nav-buttons">
//               <button className="next" onClick={handleNext}>Next</button>
//             </div>
//           </div>

//           <div className="calendar-controls">
//             <div className="location-inputs">
//               <div className="input-with-icon">
//                 <span className="icon">📍</span>
//                 <input
//                   type="text"
//                   value={tempLocation}
//                   onChange={handleChange}
//                   placeholder="Enter location"
//                 />
//                 {suggestions.length > 0 && (
//                   <ul className="dropdown">
//                     {suggestions.map((c, idx) => (
//                       <li key={idx} onClick={() => handleSelect(c.city)}>
//                         {c.city}, {c.state}, {c.country}
//                       </li>
//                     ))}
//                   </ul>
//                 )}
//               </div>

//               {/* --- Date input: update selectedDate + month/year so overview updates --- */}
//               <input
//                 type="date"
//                 onChange={(e) => {
//                   const newDate = new Date(e.target.value);
//                   // update month/year for calendar grid and API
//                   setMonth(newDate.getMonth());
//                   setYear(newDate.getFullYear());
//                   // update selectedDate so overview updates immediately
//                   setSelectedDate(newDate);
//                 }}
//               />

//               {/* ✅ Professional Submit Button */}
//               <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
//                 {/* ✅ Submit Button */}
//                               {/* Submit (keeps same behaviour) */}
//               <button
//                 className="submit-btn"
//                 onClick={handleSubmit}
//                 disabled={loading}
//                 style={{
//                   background: "linear-gradient(90deg,#0b74de,#0066cc)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 8,
//                   padding: "10px 16px",
//                   fontSize: 15,
//                   fontWeight: 600,
//                   cursor: loading ? "not-allowed" : "pointer",
//                   marginLeft: 10,
//                   boxShadow: "0 6px 14px rgba(11,116,222,0.18)"
//                 }}
//               >
//                 {loading ? "Updating..." : "Submit"}
//               </button>

//               {/* Today button */}
//               <button
//                 onClick={handleToday}
//                 disabled={loading}
//                 style={{
//                   background: "linear-gradient(90deg,#28a745,#218838)",
//                   color: "#fff",
//                   border: "none",
//                   borderRadius: 8,
//                   padding: "10px 16px",
//                   fontSize: 15,
//                   fontWeight: 600,
//                   cursor: loading ? "not-allowed" : "pointer",
//                   marginLeft: 10,
//                   boxShadow: "0 6px 14px rgba(33,136,56,0.18)"
//                 }}
//               >
//                 {loading ? "Updating..." : "Today"}
//               </button>


//               </div>


//             </div>
//           </div>

//           {showWeekdays && (
//             <div className="weekdays" id="weekdays-section">
//               <div className="c-icon">
//                 <img src={calendar} alt="err" />
//                 <span>change date</span>
//               </div>
//               <div className="c-icon">
//                 <img src={moon} alt="err" />
//                 <span>switch to amanta</span>
//               </div>
//               <div className="c-icon">
//                 <img src={scroll} alt="" />
//                 <span>switch to Lunar Base</span>
//               </div>
//               <div className="c-icon">
//                 <img src={weekDay} alt="err" />
//                 <span>WeekDays at Top</span>
//               </div>
//               <div className="c-icon">
//                 <img src={t} alt="" />
//                 <span>GoTo Today</span>
//               </div>
//               <div className="c-icon">
//                 <img src={hourglass} alt="err" />
//                 <span>Vedic Clock</span>
//               </div>
//               <div className="c-icon">
//                 <img src={setting} alt="err" />
//                 <span>Classic Theme</span>
//               </div>
//             </div>
//           )}
//         </div>

//         {/*  Always shows current date overview */}
//         <div className="date-overview">
//           <div className="overview-left">
//             <h2>
//               {dateType === "bengali"
//                 ? `${today.bengaliDate} `
//                 : `${today.hinduDate} `}
//             </h2>

//               {/* <h2>
//               {dateType === "bengali"
//                 ? `${today.bengaliDate} (${today.bengaliYear || '—'})`
//                 : `${today.hinduDate} (${today.hinduYear || '—'})`}
//             </h2> */}

//             <p>{today.paksha || '...'} Paksha , {today.tithi?.name || 'Loading...'}</p>

//             {/* {dateType === "hindu" && (
//               <p>{today.vikramSamvat || 'Loading...'} , Vikrama Samvata</p>
//             )} */}

//             {/* {dateType === "bengali" && (
//               <p>{today.shakaSamvat || 'Loading...'} , Shaka Samvata</p>
//             )} */}
//           </div>

//           <div className="overview-right">
//             <h2>{today.date}</h2>
//             <p>(24 Hour Format)</p>
//             <p>{today.monthName}, {today.year}</p>
//             <span>{today.weekday}</span>
//           </div>
//         </div>

//         <div className="calender-wrapper">
//           <div className="calendar-grid">
//             {calendarMatrix.map((row, rowIndex) => (
//               <div className="calendar-row" key={rowIndex}>
//                 <div className="weekday-label">{weekdayNames[rowIndex]}</div>
//                 {row.map((day, colIndex) => (
//                   <div
//                     className={`day-box ${day?.blurred ? 'blurred' : ''} ${day?.isToday ? 'today' : ''}`}
//                     key={colIndex}
//                   >
//                     <div className="tithi">{day?.tithi}</div>
//                     <div className="bengaliDate">{day?.bengaliDate}</div>
//                     <div className="bengaliDate">{day?.hinduDate}</div>

//                     <div className="sun-details">
//                       <div className="sunrise">{day?.sunrise}</div>
//                       <div className="day-number">{day?.date}</div>
//                       <div className="sunset">{day?.sunset}</div>
//                     </div>
//                     <div className="event">{day?.nakshatra}<br />{day.yoga}</div>
//                   </div>
//                 ))}
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default BengaliCalendar;

import React, { useState, useEffect } from 'react';
import './BengaliCalender.scss';
import calendar from '../../assets/calendar.png';
import moon from '../../assets/moon.png';
import scroll from '../../assets/scroll.png';
import weekDay from '../../assets/weekDay.png';
import t from '../../assets/t.png';
import hourglass from '../../assets/hourglass.png';
import setting from '../../assets/setting.png';
import tool from '../../assets/tool.png';
import axios from 'axios';
import city from '../../city.json';

const BengaliCalendar = ({ dateType = "bengali" }) => {
  const [showWeekdays, setShowWeekdays] = useState(false);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [location, setLocation] = useState("Kolkata, India");
  const [year, setYear] = useState(currentDate.getFullYear());
  const [month, setMonth] = useState(currentDate.getMonth());
  const [calendarData, setCalendarData] = useState([]);
  const [tempLocation, setTempLocation] = useState("Kolkata");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);

  const daysInMonth = (m, y) => new Date(y, m + 1, 0).getDate();
  const getFirstDay = (m, y) => new Date(y, m, 1).getDay();

  // ✅ API call respects dateType
  const fetchCalendarData = async () => {
    if (!location || location.trim() === '') return;
    try {
      setLoading(true);
      const res = await axios.get(
        `https://core-c343.onrender.com/api/calendar-month?location=${encodeURIComponent(location)}&year=${year}&month=${month + 1}&type=${dateType}`
      );
      setCalendarData(res.data || []);
    } catch (err) {
      console.error('Error fetching calendar data:', err);
      setCalendarData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const debounce = setTimeout(fetchCalendarData, 500);
    return () => clearTimeout(debounce);
  }, [year, month, location, dateType]);

  const generateDays = () => {
    const totalDays = daysInMonth(month, year);
    const startDay = getFirstDay(month, year);
    const prevMonthDays = daysInMonth(month - 1 < 0 ? 11 : month - 1, month - 1 < 0 ? year - 1 : year);
    const days = [];

    // Previous month’s blurred cells
    for (let i = startDay - 1; i >= 0; i--) {
      days.push({
        date: prevMonthDays - i,
        tithi: '-',
        sunrise: '-',
        sunset: '-',
        bengaliDate: '-',
        hinduDate: '-',
        blurred: true
      });
    }

    // Current month’s days
    for (let i = 1; i <= totalDays; i++) {
      const apiDay = calendarData.find(item => new Date(item.date).getDate() === i);
      const date = new Date(year, month, i);
      const isToday = date.toDateString() === selectedDate.toDateString();

      days.push({
        date: i,
        tithi: apiDay?.tithi?.name || '-',
        sunrise: apiDay?.sunrise || '-',
        sunset: apiDay?.sunset || '-',
        bengaliDate: apiDay?.bengaliDate?.formatted || '-',
        hinduDate: apiDay?.hinduDate?.formatted || '-',
        event: i === 14 ? 'Rath' : i === 25 ? 'Monthly Shivratri' : '',
        nakshatra: apiDay?.nakshatra?.name,
        yoga: apiDay?.yoga?.name,
        isToday,
        fullDate: date
      });
    }

    // Fill trailing blanks
    while (days.length % 7 !== 0) {
      days.push({
        date: days.length % 31 + 1,
        tithi: '-',
        sunrise: '-',
        sunset: '-',
        bengaliDate: '-',
        hinduDate: '-',
        blurred: true
      });
    }

    return days;
  };

  const days = generateDays();

  const todayData = calendarData.find(
    (item) => new Date(item.date).toDateString() === selectedDate.toDateString()
  );

  const today = {
    date: selectedDate.getDate(),
    month: selectedDate.getMonth(),
    year: selectedDate.getFullYear(),
    weekday: selectedDate.toLocaleString('default', { weekday: 'long' }),
    monthName: selectedDate.toLocaleString('default', { month: 'long' }),
    bengaliDate: todayData?.bengaliDate?.formatted || 'Loading',
    hinduDate: todayData?.hinduDate?.formatted || 'Loading',
    paksha: todayData?.paksha || 'Loading...',
    vikramSamvat: todayData?.vikramSamvat?.formatted || 'Loading...',
    shakaSamvat: todayData?.shakaSamvatDetails?.formatted || 'Loading...',
    bengaliYear: todayData?.shakaSamvatDetails?.year || selectedDate.getFullYear(),
    hinduYear: todayData?.vikramSamvat?.year || selectedDate.getFullYear(),
    tithi: todayData?.tithi || 'Loading...'
  };

  const weekdayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  const rows = 7;
  const columns = Math.ceil(days.length / rows);
  const calendarMatrix = Array.from({ length: rows }, (_, rowIndex) =>
    Array.from({ length: columns }, (_, colIndex) => {
      const dayIndex = colIndex * rows + rowIndex;
      return days[dayIndex] || null;
    })
  );

  const handlePrev = () => {
    let newMonth, newYear;
    if (month === 0) {
      newMonth = 11;
      newYear = year - 1;
    } else {
      newMonth = month - 1;
      newYear = year;
    }
    setMonth(newMonth);
    setYear(newYear);

    const day = selectedDate.getDate();
    const maxDay = daysInMonth(newMonth, newYear);
    setSelectedDate(new Date(newYear, newMonth, Math.min(day, maxDay)));
  };

  const handleNext = () => {
    let newMonth, newYear;
    if (month === 11) {
      newMonth = 0;
      newYear = year + 1;
    } else {
      newMonth = month + 1;
      newYear = year;
    }
    setMonth(newMonth);
    setYear(newYear);

    const day = selectedDate.getDate();
    const maxDay = daysInMonth(newMonth, newYear);
    setSelectedDate(new Date(newYear, newMonth, Math.min(day, maxDay)));
  };

  const handleChange = (e) => {
    const value = e.target.value;
    setTempLocation(value);
    if (value.length > 0) {
      const filtered = city.filter((c) =>
        c.city.toLowerCase().includes(value.toLowerCase())
      );
      setSuggestions(filtered.slice(0, 4));
    } else {
      setSuggestions([]);
    }
  };

  const handleSelect = (cityName) => {
    setTempLocation(cityName);
    setSuggestions([]);
  };

  const handleSubmit = () => {
    setLocation(tempLocation);
    setMonth(selectedDate.getMonth());
    setYear(selectedDate.getFullYear());
    setTimeout(fetchCalendarData, 0);
  };

  const handleToday = async () => {
    const now = new Date();
    setSelectedDate(now);
    setCurrentDate(now);
    setYear(now.getFullYear());
    setMonth(now.getMonth());
    try {
      setLoading(true);
      await fetchCalendarData();
    } catch (err) {
      console.error('Today click fetch error', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bengali-calendar">
      <div className="calendar-container">
        <div className="calendar-header">
          <div className="calendar-info">
            <div className="nav-buttons">
              <button className="prev" onClick={handlePrev}>Prev</button>
            </div>
            <div className="month-date">
              <h2>{new Date(year, month).toLocaleString('default', { month: 'long' })} {year}</h2>
              <p>{dateType === "bengali" ? today.bengaliDate : today.hinduDate}</p>
            </div>
            <div className="nav-buttons">
              <button className="next" onClick={handleNext}>Next</button>
            </div>
          </div>

          <div className="calendar-controls">
            <div className="location-inputs">
              <div className="input-with-icon">
                <span className="icon">📍</span>
                <input
                  type="text"
                  value={tempLocation}
                  onChange={handleChange}
                  placeholder="Enter location"
                />
                {suggestions.length > 0 && (
                  <ul className="dropdown">
                    {suggestions.map((c, idx) => (
                      <li key={idx} onClick={() => handleSelect(c.city)}>
                        {c.city}, {c.state}, {c.country}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <input
                type="date"
                onChange={(e) => {
                  const newDate = new Date(e.target.value);
                  setMonth(newDate.getMonth());
                  setYear(newDate.getFullYear());
                  setSelectedDate(newDate);
                }}
              />

              <button
                className="submit-btn"
                onClick={handleSubmit}
                disabled={loading}
                style={{
                  background: "linear-gradient(90deg,#0b74de,#0066cc)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 16px",
                  fontSize: 15,
                  fontWeight: 600,
                  cursor: loading ? "not-allowed" : "pointer",
                  marginLeft: 10,
                  boxShadow: "0 6px 14px rgba(11,116,222,0.18)"
                }}
              >
                {loading ? "Updating..." : "Submit"}
              </button>

              <button
                onClick={handleToday}
                disabled={loading}
                style={{
                  background: "linear-gradient(90deg,#28a745,#218838)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 8,
                  padding: "10px 16px",
                  fontSize: 15,
                  fontWeight: 600,
                  cursor: loading ? "not-allowed" : "pointer",
                  marginLeft: 10,
                  boxShadow: "0 6px 14px rgba(33,136,56,0.18)"
                }}
              >
                {loading ? "Updating..." : "Today"}
              </button>
            </div>
          </div>
        </div>

        {/* Current day overview */}
        <div className="date-overview">
          <div className="overview-left">
            <h2>
              {dateType === "bengali"
                ? `${today.bengaliDate}`
                : `${today.hinduDate}`}
            </h2>
            <p>{today.paksha || '...'} Paksha , {today.tithi?.name || 'Loading...'}</p>
          </div>

          <div className="overview-right">
            <h2>{today.date}</h2>
            <p>(24 Hour Format)</p>
            <p>{today.monthName}, {today.year}</p>
            <span>{today.weekday}</span>
          </div>
        </div>

        {/* ✅ Unified calendar grid (uses prop to choose date type) */}
        <div className="calender-wrapper">
          <div className="calendar-grid">
            {calendarMatrix.map((row, rowIndex) => (
              <div className="calendar-row" key={rowIndex}>
                <div className="weekday-label">{weekdayNames[rowIndex]}</div>
                {row.map((day, colIndex) => (
                  <div
                    className={`day-box ${day?.blurred ? 'blurred' : ''} ${day?.isToday ? 'today' : ''}`}
                    key={colIndex}
                  >
                    <div className="tithi">{day?.tithi}</div>
                    <div className="bengaliDate">
                      {dateType === "bengali" ? day?.bengaliDate : day?.hinduDate}
                    </div>
                    <div className="sun-details">
                      <div className="sunrise">{day?.sunrise}</div>
                      <div className="day-number">{day?.date}</div>
                      <div className="sunset">{day?.sunset}</div>
                    </div>
                    <div className="event">{day?.nakshatra}<br />{day.yoga}</div>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BengaliCalendar;

